<lor-report [reportVariant]="this.reportVariant" [programmeOptions]="this.programmeOptions"
  [reportName]="this.reportName"></lor-report>